// extracted by mini-css-extract-plugin
export var sliderRange = "_my-2";
export var sliderRoot = "_my-0";
export var sliderThumb = "_my-3";
export var sliderTrack = "_my-1";